import { Commit, Dispatch } from 'vuex';
import { UPDATE_BASIC_TABLE_SCHEMA, UPDATE_BASIC_TABLE_DATA } from '@/main/store/listEditTypes';
import { commitAction } from '@/main/store/actionsFunctions';

import { listActions } from '../types';
import { apiProvider } from '../../api';
import { NahradyFilter } from './types';

export const actions = {
	[listActions.Nahrady_TABLE_SCHEMA]: ({ commit, dispatch }: { commit: Commit, dispatch: Dispatch }) => commitAction(
		commit,
		dispatch,
		apiProvider.nahradyTableSchema(),
		'localState.nahradyTable',
		UPDATE_BASIC_TABLE_SCHEMA,
		{ tableName: 'localState.nahradyTable' },
	),


	[listActions.Nahrady_TABLE_DATA]: (
		{ commit, dispatch }: { commit: Commit, dispatch: Dispatch },
		{ nahradyFilter }: { nahradyFilter: NahradyFilter },
	) => commitAction(
		commit,
		dispatch,
		apiProvider.nahradyTableData(nahradyFilter),
		'localState.nahradyTable',
		UPDATE_BASIC_TABLE_DATA,
		{ tableName: 'localState.nahradyTable' },
	),
};
